import { ReactSession } from "../../../lib/secure_reactsession";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import React, { useEffect, useState, useRef } from "react";
import { Button } from "../../themes/userq/Button/Button";
import { Icon } from "../../themes/userq/Icon/Icon";
import { Text } from "../../themes/userq/Text/Text";
import { CheckBox } from "../../themes/userq/CheckBox/CheckBox";
import { showToast } from "../../../lib/helpers";


export default function VideoUploadModal({ openModal,
    closeModal,videomodalCallback}) {
  const navigate = useNavigate();
  const wrapperRef = useRef(null);
  

  /* function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
       if (ref.current && !ref.current.contains(event.target)) {
          if (event.target.nodeName == "DIV") {
            !ReactSession.get("token")
              ? navigate("/tester/sign-in")
              : navigate("/");
          }
        }
        
         
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(wrapperRef); */
  setTimeout(()=>{
    videomodalCallback();
    
  },1000)

  return (
    <Modal
      show={openModal}
      centered
      className="fade custom-modal-wrap  video-processing-modal "
    >
      <Modal.Body
        className={"p-28"}
        ref={wrapperRef}
      >
        <div className="modal-inner-text">
         
          <div className="congrats-modal-header-step-second mb-1 d-flex justify-content-center">
              <img width={'80px'} src={ process.env.REACT_APP_URL + "img/download.svg" } />
          </div>

          <div className="nda-modal-text mt-20">
            <div className="text-center">
        
              <Text type={"h3"} fontWeight={"bold-font"}>
                Upload in Progress
              </Text>
              <div className="mt-20 mb-32">
                <Text type={'body-text-3'} fontWeight={'medium-font'}>Please wait while your recording is being uploaded. The credits will be added to your account once the upload completed please do not close this page until the upload is complete.</Text>
              </div>
              
            <div/>
          </div>
        </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
